import React from 'react';
import logo from '../../assets/images/logo-ct-dark.png';

const LoadingSpinner = ({ message = "Cargando..." }) => {
  return (
    <div className="loading-screen">
      <div className="loader">
        <img src={logo} alt={message} className="loading-logo" />
      </div>
      <style>{`
        .loading-screen {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          background-color: rgba(255, 255, 255, 0.8);
          animation: fadeIn 0.5s ease-in-out;
        }
        .loader {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .loading-logo {
          width: 100px;
          height: 100px;
          animation: spin 2s linear infinite;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
